import { ControlFilteredOptionLoader } from '../../../shared/utils/control-filtered-option-loader';
import { Equipment } from '../contract/equipment.contract';
import { AlarmType, isAlarmTypeSupportSharedEquipments } from '../enums/alarm-type.enum';

type EquipmentControlFilteredOptionLoaderParams = {
  term: string;
  excludeShared: boolean;
};

export class EquipmentControlFilteredOptionLoader extends ControlFilteredOptionLoader<Equipment, EquipmentControlFilteredOptionLoaderParams> {
  private _term = '';
  private _excludeShared = false;

  searchChange(term: string): void {
    this._term = term;
    this.load({ term, excludeShared: this._excludeShared });
  }

  alarmTypeChange(alarmType: AlarmType): void {
    const excludeShared = !isAlarmTypeSupportSharedEquipments(alarmType);

    if (excludeShared !== this._excludeShared) {
      this.control?.reset();
      this.load({ term: this._term, excludeShared: excludeShared });
    }
    this._excludeShared = excludeShared;
  }
}
